import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Grid, IconButton, Menu, MenuItem, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Notes } from '../../../../api/Endpoints/Notes';
import { toast } from 'react-toastify';
import moment from 'moment';
import Delete from '../../../../components/Popup/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { LoadingButton } from '@mui/lab';
import CurrentDateInput from '../../../../components/Form/CurrenDateInput';
import DateIn from '../../../../components/Form/Date';


export default function AddNotes({ viewID, refreshParent, isActive }) {
    const schema = yup.object().shape({
        notes: yup.string().required('Field is required'),
    });


    const { register, handleSubmit, formState: { errors }, reset, watch, control, setValue } = useForm({
        resolver: yupResolver(schema),
    });

    const [listNotes, setListNotes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [DeleteID, setDeleteID] = useState(0)
    const [refresh, setRefresh] = useState()
    const [formButtonStatus, setFormButtonStatus] = useState({
        label: "Submit",
        loading: false,
        disabled: false,
    });
    const [editingNoteId, setEditingNoteId] = useState(null);
    const [editedNote, setEditedNote] = useState("");

    // Debugging: Log the viewID to see what's being passed
    useEffect(() => {
        console.log("AddNotes component - viewID:", viewID, "Type:", typeof viewID, "isActive:", isActive);
    }, [viewID, isActive]);

    // Convert viewID to a valid format if it's a string number
    const getValidId = () => {
        
        
        if (!viewID) return null;
        if (typeof viewID === 'string') {
            // Check if it's a string representation of a number
            const num = parseInt(viewID, 10);
            return isNaN(num) ? viewID : num;
        }
        return viewID;
    };

    const validId = getValidId();

    const fetchNotes = () => {
        // More permissive validation - allow string numbers and check if they're valid
        const isValidId = validId && validId !== "" && validId !== "undefined" && validId !== "null";
        
        if (!isValidId) {
            console.log("Skipping fetchNotes - invalid viewID:", viewID, "validId:", validId);
            setLoading(false);
            return;
        }
        
        setLoading(true);
        Notes.getNotes({ id: validId||viewID })
            .then((response) => {
                console.log({res:response?.data?.data});
                
                setListNotes(response.data.data);
            })
            .catch((err) => {
                console.log("Error fetching notes:", err);
                toast.error("Failed to fetch notes");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const TableUpdate = () => {
        setRefresh(Math.random);
        // Notify parent to refresh notes
        if (refreshParent) {
            refreshParent();
        }
    }
    
    // Fetch notes when component mounts and when viewID or refresh changes
    // Also fetch when component becomes active
    useEffect(() => {
        fetchNotes();
    }, [viewID, refresh]);

    const onSubmit = (data) => {
        // More permissive validation for the ID
        const isValidId = validId && validId !== "" && validId !== "undefined" && validId !== "null";
        
        if (!isValidId) {
            toast.error("Invalid lead ID - please try again");
            console.log("Submit blocked - invalid viewID:", viewID, "validId:", validId);
            return;
        }
        
        setFormButtonStatus({ ...formButtonStatus, loading: true, disabled: true });
        const noteDate = data.note_date != null ? moment(data.note_date).format("YYYY-MM-DD") : '';
        const dataToSubmit = {
            id: validId, // Use the validated ID
            notes: data.notes,
            note_date: noteDate
        };

        Notes.add(dataToSubmit)
            .then((response) => {
                if (response.data.status === true) {
                    toast.success('Note assigned successfully');
                    setFormButtonStatus({ ...formButtonStatus, loading: false, disabled: false });
                    reset(); // Reset the form after successful submission
                    TableUpdate()
                } else {
                    toast.error(response.data.message || 'Failed to save note');
                    setFormButtonStatus({ ...formButtonStatus, loading: false, disabled: false });
                }
            })
            .catch((err) => {
                console.error("Error saving note:", err);
                toast.error("Failed to save note");
                setFormButtonStatus({ ...formButtonStatus, loading: false, disabled: false });
            });
    };


    const handleDelete = (id) => {
        setDeleteID(id)
    };

    const handleEdit = (id, note, date) => {
        setValue('edit_date', date)
        setEditingNoteId(id);
        setEditedNote(note);
    };

    const handleSaveEdit = (id) => {
        // More permissive validation for the ID
        const isValidId = validId && validId !== "" && validId !== "undefined" && validId !== "null";
        
        if (!isValidId) {
            toast.error("Invalid lead ID - please try again");
            console.log("Save edit blocked - invalid viewID:", viewID, "validId:", validId);
            return;
        }
        
        const noteDate = watch('edit_date') != null ? moment(watch('edit_date')).format("YYYY-MM-DD") : '';

        Notes.UpdateNotes({ 
            id: id, 
            notes: editedNote, 
            note_date: noteDate 
        })
            .then((response) => {
                if (response.data.status === true) {
                    fetchNotes();
                    setEditingNoteId(null);
                    setEditedNote("");
                    toast.success('Note updated successfully');
                } else {
                    toast.error(response.data.message || 'Failed to update note');
                }
            })
            .catch((err) => {
                console.error("Error updating note:", err);
                toast.error(err?.data?.message||err?.response?.data?.message||"Failed to update note");
                setEditingNoteId(null);
                setEditedNote("");
            });
    };

    // More permissive check for button disabled state
    const isViewIdValid = validId && validId !== "" && validId !== "undefined" && validId !== "null";

    return (
        <>
            <Delete
                DeleteID={DeleteID}
                setDeleteID={setDeleteID}
                Callfunc={fetchNotes}
                url={'/lead/delete-note'}
                title={'Note'}
            />
            <Grid item xs={12} sm={6} className='tab-notes'>
                <CurrentDateInput
                    control={control}
                    name="note_date"
                // readOnly={props.editId ? true : false}
                />
            </Grid>
            <div className="pop-note">
                <form className='add-note-block-content' onSubmit={handleSubmit(onSubmit)}>

                    <Grid className='add-note-block' container alignItems="center" sx={{ p: 1 }} item xs={12}>
                        <TextField className='add-note-block-textarea'
                            sx={{ width: '70%' }}
                            {...register('notes')}
                            label="Add Note"
                            size="medium"
                            multiline
                            rows={4}
                            id="outlined-multiline-static"
                            error={Boolean(errors.notes)}
                        />
                        <LoadingButton 
                            id="notes-add-btn" 
                            loading={formButtonStatus.loading} 
                            disabled={formButtonStatus.disabled || !isViewIdValid}
                            variant="outlined" 
                            type="submit"
                        >
                            {formButtonStatus.label}
                        </LoadingButton>
                    </Grid>
                </form>
                <div className='talk-bubble-block'>
                    {loading ? (
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                height: '30vh',
                            }}
                        >
                            <CircularProgress />
                        </Box>
                    ) : (
                        <TableContainer className='note-result-block'>
                            <Table>
                                <TableBody>
                                    {listNotes.length > 0 && <Typography textTransform={'uppercase'}>Notes</Typography>}
                                    {listNotes.map((item) => (
                                        <TableRow key={item.id}>
                                            <TableCell className='note-content'>

                                                {editingNoteId === item.id ? (
                                                    <>
                                                        <TextField
                                                            value={editedNote}
                                                            onChange={(e) => setEditedNote(e.target.value)}
                                                            fullWidth
                                                            multiline
                                                            rows={3}
                                                            variant="outlined"
                                                        />
                                                        <Grid item xs={12} sm={6}>
                                                            <DateIn
                                                                control={control}
                                                                name="edit_date"
                                                                value={watch('edit_date')}
                                                            />
                                                        </Grid>
                                                    </>
                                                ) : (
                                                    item.notes
                                                )}

                                            </TableCell>
                                            <TableCell className='note-name'>
                                                {item.created_user.name}
                                                <TableCell>{moment(item.note_date).format('DD MMM, YYYY')}</TableCell>
                                            </TableCell>
                                            <TableCell>
                                                {editingNoteId === item.id ?
                                                    <Button 
                                                        onClick={() => handleSaveEdit(item.id)} 
                                                        variant='outlined'
                                                        disabled={!isViewIdValid}
                                                    >
                                                        Save
                                                    </Button> :
                                                    <IconButton onClick={() => handleEdit(item.id, item.notes, item?.note_date)}>
                                                        <EditIcon className="edit-icon" style={{ color: 'blue' }} />
                                                    </IconButton>
                                                }
                                            </TableCell>
                                            <TableCell>
                                                <IconButton onClick={() => handleDelete(item.id)}>
                                                    <DeleteIcon className="delete-icon" style={{ color: 'red' }} />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer >
                    )}
                </div >
            </div >
        </>
    );
}